export const CREATE_NOTIFICATION = 'spaces/publisher/notification/CREATE'
export const CREATE_NOTIFICATION_SUCCESS = `${CREATE_NOTIFICATION}_SUCCESS`

export const CREATE_DRAFT_NOTIFICATION = 'spaces/publisher/draftNotification/CREATE'
export const CREATE_DRAFT_NOTIFICATION_SUCCESS = `${CREATE_DRAFT_NOTIFICATION}_SUCCESS`

export const UPDATE_DRAFT_NOTIFICATION = 'spaces/publisher/draftNotification/UPDATE'
export const UPDATE_DRAFT_NOTIFICATION_SUCCESS = `${UPDATE_DRAFT_NOTIFICATION}_SUCCESS`
